<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="headerItems" />

        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-input">
                <a class="btn btn-searchset">
                  <img src="../../../assets/img/icons/search-white.svg" alt="search" />
                </a>
                <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Search by role name or description" />
              </div>
              <button class="btn btn-outline-secondary btn-sm" @click="loadRoles" :disabled="loading">
                {{ loading ? 'Refreshing...' : 'Refresh' }}
              </button>
            </div>

            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="loading" class="state-wrap">Loading roles...</div>

            <div v-else class="table-responsive">
              <table class="table table-hover align-middle">
                <thead>
                  <tr>
                    <th>Role</th>
                    <th>Description</th>
                    <th>Permissions</th>
                    <th>Status</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="role in filteredRoles" :key="role.roleid">
                    <td>{{ role.rolename }}</td>
                    <td>{{ role.description || '-' }}</td>
                    <td>{{ (role.permissions || []).length }}</td>
                    <td>
                      <span :class="role.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                        {{ role.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td class="text-end">
                      <router-link v-if="canManageRoles" class="me-3" :to="{ name: 'editpermission', query: { id: role.roleid } }">
                        <img src="../../../assets/img/icons/edit.svg" alt="edit" />
                      </router-link>
                      <a v-if="canManageRoles" href="javascript:void(0);" @click="removeRole(role)">
                        <img src="../../../assets/img/icons/delete.svg" alt="delete" />
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!filteredRoles.length">
                    <td colspan="5" class="text-center text-muted py-4">No roles found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'grouppermissions',
  data() {
    return {
      title: 'Roles & Permissions',
      title1: 'Manage reusable role definitions',
      search: '',
      roles: [],
      loading: false,
      errorMessage: '',
    };
  },
  computed: {
    headerItems() {
      return this.$store.getters.hasPermission('users.manage_roles')
        ? [{ text: 'Add Role', addname: '/createpermission' }]
        : [];
    },
    canManageRoles() {
      return this.$store.getters.hasPermission('users.manage_roles');
    },
    filteredRoles() {
      const term = this.search.trim().toLowerCase();
      if (!term) {
        return this.roles;
      }

      return this.roles.filter((role) => {
        const haystack = [role.rolename, role.description].join(' ').toLowerCase();
        return haystack.includes(term);
      });
    },
  },
  methods: {
    async loadRoles() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const response = await axios.get('/v1/access/roles');
        this.roles = response.data || [];
      } catch (error) {
        this.errorMessage = error.response?.data?.detail || 'Failed to load roles.';
      } finally {
        this.loading = false;
      }
    },
    async removeRole(role) {
      const result = await Swal.fire({
        title: 'Delete role?',
        text: `This will remove ${role.rolename}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF9F43',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        await axios.delete(`/v1/access/roles/${role.roleid}`);
        this.roles = this.roles.filter((item) => item.roleid !== role.roleid);
        Swal.fire({ icon: 'success', title: 'Deleted', timer: 1200, showConfirmButton: false });
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Delete failed', text: error.response?.data?.detail || 'Could not delete role.' });
      }
    },
  },
  mounted() {
    this.loadRoles();
  },
};
</script>

<style scoped>
.table-top { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:16px; flex-wrap:wrap; }
.search-input { display:flex; align-items:center; gap:6px; min-width:280px; }
.search-input input { max-width:360px; }
.state-wrap { padding:24px; color:#6b7280; }
</style>
